<template>
  <a-card style="flex: 1;margin-left: 24px;">
    供需论坛
  </a-card>
</template>

<script>
import commonErpPageScript from '@/components/common/commonErpPageScript';

export default {
  name: "forum",
  mixins: [commonErpPageScript],
  data(){
    return {

    }
  },
  computed: {
    columns(){

    },
  },
}
</script >

<style scoped lang="scss">


</style>